import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { io } from "socket.io-client";

import api from "../../service/api";

import { 
    Container, 
    ChatHeader,
    BackButton,
    LogoContainer,
    LogoImage,
    ChatSubject, 
    ChatDetail, 
    StatusContainer, 
    ChatBody, 
    ChatMessagesContainer,
    MessageBlock,
    Message,
    MessageText,
    MessageFooter,
    FormContainer,
    Textarea,
    SendButtonContainer,
    SendButton
} from "./styles";

//Actions Functions
import { newMessage } from "../../redux/actions/messages";

//Assets
import logo from "../../assets/img/logo-example.png";
import sendGray from "../../assets/icons/send-gray.svg";
import sendWhite from "../../assets/icons/send-white.svg";
import backArrowOrange from "../../assets/icons/back-arrow-orange.svg";

//Interfaces
import { ChatComponentPropsInterface } from "./interfaces";

//Data
import {messages} from "../../data/messages";
import { addressImage } from "../../service/domains";

const Chat = (props: ChatComponentPropsInterface) => {
    const [ isSendButtonHover, setIsSendButtonHover ] = useState(false);
    const [ messagesForThisChat, setMessagesForThisChat ] = useState<Array<any>>([]);
    // const [ chatId, setChatId ] = useState(props.chatData);

    const login = useSelector((state: {login: any}) => state.login);
    const websocket = useSelector((state: {websocket: any}) => state.websocket)
    const messages = useSelector((state: {messages: any}) => state.messages);

    const dispatch = useDispatch();

    useEffect(() => {
        const getChatMessagesAtApi = async () => {
            const { data } = await api.get("/chat/title/list", {
                params: {
                    chatId: props.chatData.ch_id
                }
            });
        }
        
        if(props.chatData.id !== ""){
            getChatMessagesAtApi()
        }
    }, [props.chatData.id])

    useEffect(() => {
        const messagesWithThisChatId = messages.messageAcc.filter((message: any) => message.chatId === props.chatData.ch_id);
        
        setMessagesForThisChat(messagesWithThisChatId);
    }, [messages, props.chatData]);

    const messagesGenerator = () => {
        return messagesForThisChat.map((message: any, index) => {
            return(
                <MessageBlock key={index} isUserMessage={message.from === "attendant"}>
                    <Message isUserMessage={message.from === "attendant"}>
                        <MessageText>{message.text}</MessageText>
                        {/* <MessageFooter>{message.date}</MessageFooter>                */}
                    </Message>
                </MessageBlock>
            )
        })
    }

    const handleResolvedChat = async () => {
        const chatStringfied = JSON.stringify(messagesForThisChat);
        const { data } = await api.post("chat/items/create", {
            "chatId": props.chatData.id,
            // "userId": login.user.id,
            "message": chatStringfied
        });
    }

    const getProtocol = () => {
        const protocol = props.chatData.ch_id.split("-");
        
        return protocol[0]
    }

    return(
        <Container>
            <ChatHeader>
                <div className="d-flex align-items-center">
                    <BackButton onClick={() => props.backToConversations ? props.backToConversations(true) : null}>
                        <img src={backArrowOrange}/>
                    </BackButton>
                    <LogoContainer>
                        <LogoImage src={`${addressImage}${props.chatData.br_standardLogo}`} alt="logo"/>
                    </LogoContainer>

                    <div>
                        <ChatSubject>{props.chatData.title}</ChatSubject>
                        <div className="d-flex">
                            <ChatDetail>Protocolo: {getProtocol()}</ChatDetail>
                            <ChatDetail>{moment(props.chatData.created_at).format("DD/MM/YYYY hh:mm")}</ChatDetail>
                        </div>
                    </div>

                </div>
                <StatusContainer onClick={() => handleResolvedChat()}>
                    <span style={{textAlign: "center"}}>Marcar como resolvido</span>
                </StatusContainer>
            </ChatHeader>

            <ChatBody>
                <ChatMessagesContainer>
                    { messagesGenerator() }
                </ChatMessagesContainer>
                <Formik
                    initialValues={{
                        message: ""
                    }}
                    onSubmit={(values, {resetForm}) => {
                        websocket.socket.emit("sendMessage", {
                            chatId: props.chatData.id,
                            message: values.message,
                            userId: login.user.id,
                            branchId: props.chatData.ch_branchsId
                        })
                        dispatch(newMessage(
                            {
                                chatId: props.chatData.ch_id,
                                from: "attendant",
                                text: values.message
                            }
                        ));
                        resetForm();
                    }}
                >
                    <Form style={{height: window.screen.height > 768 ? "10%" : "18%"}}>
                        <FormContainer>
                            <Field id="message" name="message" placeholder="Escreva sua mensagem aqui..." as={Textarea}/>
                            <SendButtonContainer>
                                <SendButton
                                    onMouseEnter={() => setIsSendButtonHover(true)}
                                    onMouseLeave={() => setIsSendButtonHover(false)}
                                    type="submit"
                                >
                                    <img src={isSendButtonHover ? sendWhite : sendGray} style={{marginRight: 14}}/>
                                    Enviar
                                </SendButton>
                            </SendButtonContainer>
                        </FormContainer>
                    </Form>
                </Formik>
            </ChatBody>
        </Container>
    )
}

export default Chat;